import { useNavigate } from 'react-router-dom';
import { useStore } from '../../store';
import { useToast } from './useToast';

export function useLogin() {
  const loginStore = useStore((s) => s.login);
  const navigate = useNavigate();
  const { showToast } = useToast();

  return async (tokens: { accessToken: string }) => {
    try {
      await loginStore(tokens);

      // Check for stored redirect URL from deep linking
      const redirectUrl = sessionStorage.getItem('redirectUrl');

      if (redirectUrl) {
        sessionStorage.removeItem('redirectUrl'); // Clean up
        // Use setTimeout to ensure state is fully updated
        setTimeout(() => {
          navigate(redirectUrl, { replace: true });
        }, 100);
      } else {
        navigate('/administration');
      }
    } catch (error) {
      console.error('useLogin: Error during login:', error);
      showToast('error', 'Login Failed', 'Please check your credentials.');
    }
  };
}
